import * as Yup from 'yup';

const objectIdRegex = /^[a-f\d]{24}$/i;

const defaultOrder = {
    propertyId: '',
    buildingName: '',
    vendorId: '',
    orderedItems: [
        {
            item_id: '',
            requestedQuantity: '',
            requestsSupported: '',
            price: '',
            jobName: '',
        },
    ],
    deliveryStatus: '',
    comments: '',
};

export const orderSchema = Yup.object().shape({
    propertyId: Yup.string()
        .required('Property ID is required')
        .test('is-object-id', 'Invalid Property ID', value => !value || objectIdRegex.test(value)),
    buildingName: Yup.string().required('Building name is required'),
    vendorId: Yup.string()
        .required('Vendor ID is required')
        .test('is-object-id', 'Invalid Vendor ID', value => !value || objectIdRegex.test(value)),
    orderedItems: Yup.array().of(
        Yup.object().shape({
            item_id: Yup.string()
                .required('Item ID is required')
                .test('is-object-id', 'Invalid Item ID', value => !value || objectIdRegex.test(value)),
            requestedQuantity: Yup.number()
                .required('Quantity is required')
                .min(1, 'Quantity must be at least 1')
                .integer('Quantity must be a whole number'),
            requestsSupported: Yup.string()
                .optional()
                .test('is-object-id', 'Invalid Request Type ID', value => !value || objectIdRegex.test(value)),
            price: Yup.number()
                .required('Price is required')
                .min(0, 'Price cannot be negative'),
            jobName: Yup.string()
                .required('Job name is required'),
        })
    ).min(1, 'At least one item must be ordered'),
    deliveryStatus: Yup.string().optional(),
    comments: Yup.string().optional(),
});

export const updateOrderSchema = Yup.object().shape({
    orderId: Yup.string()
        .required('Order ID is required')
        .test('is-object-id', 'Invalid Order ID', value => !value || objectIdRegex.test(value)),
    propertyId: Yup.string()
        .optional()
        .test('is-object-id', 'Invalid Property ID', value => !value || objectIdRegex.test(value)),
    buildingName: Yup.string().optional(),
    vendorId: Yup.string()
        .optional()
        .test('is-object-id', 'Invalid Vendor ID', value => !value || objectIdRegex.test(value)),
    orderedItems: Yup.array().of(
        Yup.object().shape({
            item_id: Yup.string()
                .required('Item ID is required')
                .test('is-object-id', 'Invalid Item ID', value => !value || objectIdRegex.test(value)),
            requestedQuantity: Yup.number()
                .required('Quantity is required')
                .min(1, 'Quantity must be at least 1')
                .integer('Quantity must be a whole number'),
            requestsSupported: Yup.string()
                .optional()
                .test('is-object-id', 'Invalid Request Type ID', value => !value || objectIdRegex.test(value)),
            price: Yup.number()
                .required('Price is required')
                .min(0, 'Price cannot be negative'),
            jobName: Yup.string()
                .required('Job name is required'),
        })
    ).min(1, 'At least one item must be ordered'),
    deliveryStatus: Yup.string().optional(),
    comments: Yup.string().optional(),
});

export const getValidationSchema = (modal) => {
    if (modal === 'add') {
        return orderSchema;
    } else if (modal === 'edit') {
        return updateOrderSchema;
    }
    return orderSchema;
};

export const getInitialValues = (modal, selectedOrder, preservedValues = {}) => {
    if (modal === 'add') {
        return {
            ...defaultOrder,
            orderedItems: [
                {
                    item_id: '',
                    requestedQuantity: 1,
                    requestsSupported: '',
                    price: 0,
                    jobName: '',
                },
            ],
            ...preservedValues,
        };
    } else if (modal === 'edit' && selectedOrder) {
        return {
            orderId: selectedOrder._id || '',
            propertyId: selectedOrder.propertyId?._id || selectedOrder.propertyId || '',
            buildingName: selectedOrder.buildingName || '',
            vendorId: selectedOrder.vendorId?._id || selectedOrder.vendorId || '',
            orderedItems: selectedOrder.orderedItems
                ? selectedOrder.orderedItems.map(item => ({
                    item_id: item.item_id || '',
                    requestedQuantity: item.requested_quantity || item.requestedQuantity || 1,
                    requestsSupported: item.requestsSupported || '',
                    price: item.price || 0,
                    jobName: item.jobName || '',
                }))
                : [
                    {
                        item_id: '',
                        requestedQuantity: 1,
                        requestsSupported: '',
                        price: 0,
                        jobName: '',
                    },
                ],
            status: selectedOrder.status || '',
            deliveryStatus: selectedOrder.delivery?.status || '',
            comments: selectedOrder.delivery?.comments || '',
        };
    }

    return {
        ...defaultOrder,
        orderedItems: [
            {
                item_id: '',
                requestedQuantity: 1,
                requestsSupported: '',
                price: 0,
                jobName: '',
            },
        ],
        ...preservedValues,
    };
};